import type { ThunkExperiments } from '@library/experimentation'

import { actionTypes } from 'actions/actionTypes'
import { promoApply, promoChange } from 'actions/promos'
import { redirect } from 'actions/redirect'
import { clickGetStarted } from 'actions/trackingKeys'
import { PROMO_CODE_DATA, TAPERED_DISCOUNT_BOX } from 'routes/Home/homeConfig'
import { getPromoBannerState, hasConsentForAnalytics } from 'routes/Home/homeUtils'
import type { ThunkActionCreator } from 'routes/Home/types/ThunkActionCreator'
import { getIsAuthenticated } from 'selectors/auth'
import { getUTMAndPromoCode } from 'selectors/tracking'
import logger from 'utils/logger'

export const applyPromoCode: ThunkActionCreator =
  () =>
  async (dispatch, getState, { experiments }: ThunkExperiments) => {
    const state = getState()
    const isAuthenticated = getIsAuthenticated(state)
    const hasAcceptedCookies = hasConsentForAnalytics()
    const shouldBeAllocatedToExperiment = !isAuthenticated && hasAcceptedCookies
    const { canApplyPromo } = getPromoBannerState(state)
    if (!canApplyPromo) {
      return
    }

    let enabled = false
    let variationKey: string | null | undefined

    if (experiments && shouldBeAllocatedToExperiment) {
      try {
        const decision = experiments.decide('beetroots_ofx_tapered_discount_curve')
        enabled = decision.enabled
        variationKey = decision.variationKey
      } catch (err) {
        logger.warning(`error deciding tapered discount curve - ${(err as Error).message}`)
      }
    }

    const isTaperedDiscountCurveEnabled = enabled && variationKey === 't1'

    const promoCode = isTaperedDiscountCurveEnabled
      ? TAPERED_DISCOUNT_BOX.defaultPromoCode
      : PROMO_CODE_DATA.defaultPromoCode

    try {
      await dispatch(promoChange(promoCode))
      await dispatch(promoApply())
    } catch (err) {
      logger.warning(`error fetching promo code ${promoCode} - ${(err as Error).message}`)
    }
  }

export const trackGetStarted: ThunkActionCreator =
  (trackingSectionName: string) =>
  (dispatch, getState, { experiments }) => {
    const { promoCode, UTM } = getUTMAndPromoCode(getState())
    experiments.track('start_onboarding')
    dispatch({
      type: actionTypes.TRACKING,
      trackingData: {
        actionType: clickGetStarted,
        section: trackingSectionName,
        ...UTM,
        promoCode,
      },
    })
  }

export const homeGetStarted: ThunkActionCreator =
  (ctaUri: string, sectionForTracking?: string) => async (dispatch) => {
    if (sectionForTracking) {
      dispatch(trackGetStarted(sectionForTracking))
    }

    await dispatch(applyPromoCode())

    dispatch(redirect(ctaUri))
  }
